document.addEventListener('DOMContentLoaded', function () {
    const _locales = {
        en: {
            "sihirbaz.button_label": "Get Suggestion",
            "sihirbaz.searching": "Searching...",
            "sihirbaz.products_loading": "Products loading...",
            "sihirbaz.invalid_measurements": "Please enter valid measurements. Zero or negative values are not allowed.",
            "sihirbaz.invalid_format": "Measurement format not recognized. Please enter like 10 x 9 x 3.",
            "sihirbaz.no_product_data": "Product data could not be loaded or found. Please refresh the page and try again.",
            "sihirbaz.exact_match_title": "Exact Matching Product:",
            "sihirbaz.nearest_title": "Best Fit Products:",
            "sihirbaz.no_results": "No product fitting these dimensions was found.",
            "sihirbaz.contact_cta_html": "Didn't find what you're looking for? For custom sizes <a href=\"https://kutufix.com/pages/teklif-sayfasi\">contact us</a>.",
            "sihirbaz.product_inspect": "Inspect product",
            "sihirbaz.price_label": "Price:",
            "sihirbaz.size_label": "Matched size:"
        },
        tr: {
            "sihirbaz.button_label": "Öneri Al",
            "sihirbaz.searching": "Aranıyor...",
            "sihirbaz.products_loading": "Ürünler Yükleniyor...",
            "sihirbaz.invalid_measurements": "Lütfen geçerli ölçüleri girin. 0 veya negatif değerler kabul edilmez.",
            "sihirbaz.invalid_format": "Ölçü formatı anlaşılamadı. Lütfen 10 x 9 x 3 gibi girin.",
            "sihirbaz.no_product_data": "Ürün verileri yüklenemedi veya bulunamadı. Lütfen sayfayı yenileyip tekrar deneyiniz.",
            "sihirbaz.exact_match_title": "Birebir Eşleşen Ürün:",
            "sihirbaz.nearest_title": "En Uygun Ölçüdeki Ürünler:",
            "sihirbaz.no_results": "Girilen ölçülere uygun bir ürün bulunamadı.",
            "sihirbaz.contact_cta_html": "Aradığınızı bulamadınız mı? Özel ölçü için <a href=\"https://kutufix.com/pages/teklif-sayfasi\">bizimle iletişime geçin</a>.",
            "sihirbaz.product_inspect": "Ürünü İncele",
            "sihirbaz.price_label": "Fiyat:",
            "sihirbaz.size_label": "Eşleşen ölçü:"
        }
    };

    function detectLang() {
        const htmlLang = document.documentElement.lang || '';
        return /^tr/i.test(htmlLang) ? 'tr' : 'en';
    }

    const activeLang = (window.sihirbazTranslations && window.sihirbazTranslations.lang) || detectLang();

    function t(key) {
        if (window.sihirbazTranslations && window.sihirbazTranslations[key]) return window.sihirbazTranslations[key];
        if (window.themeTranslations && window.themeTranslations[key]) return window.themeTranslations[key];
        const map = _locales[activeLang] || _locales.en;
        return map[key] || key;
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function sortDims(arr) {
        return arr.slice().sort(function (a, b) {
            return a - b;
        });
    }

    function normalizeNumber(value) {
        return Number.isInteger(value) ? String(value) : value.toFixed(1);
    }

    function sizeArrayToKey(arr) {
        return arr.map(normalizeNumber).join('x');
    }

    function formatSize(arr) {
        return arr.map(normalizeNumber).join(' x ') + ' cm';
    }

    function titleHasDimensions(title) {
        return /(\d+(?:[.,]\d+)?\s*[x×✕✖]\s*\d+(?:[.,]\d+)?\s*[x×✕✖]\s*\d+(?:[.,]\d+)?)/i.test(String(title || ''));
    }

    function normalizeSizeToken(token) {
        if (!token) return null;

        const match = String(token).match(/^\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?\s*[x×✕✖]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?\s*[x×✕✖]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?\s*$/i);
        if (!match) return null;

        const result = [];

        for (let i = 1; i <= 5; i += 2) {
            const value = parseFloat(String(match[i]).replace(',', '.'));
            const unit = (match[i + 1] || 'cm').toLowerCase();

            if (isNaN(value) || value <= 0) {
                return null;
            }

            result.push(parseFloat((unit === 'mm' ? value * 0.1 : value).toFixed(1)));
        }

        return result;
    }

    function tokenizeSizes(raw) {
        if (!raw) return [];

        const results = [];
        const text = String(raw);
        const regex = /(\d+(?:[.,]\d+)?\s*(?:cm|mm)?\s*[x×✕✖]\s*\d+(?:[.,]\d+)?\s*(?:cm|mm)?\s*[x×✕✖]\s*\d+(?:[.,]\d+)?\s*(?:cm|mm)?)/gi;
        let match;

        while ((match = regex.exec(text)) !== null) {
            const normalized = normalizeSizeToken(match[1]);
            if (normalized) {
                results.push(normalized);
            }
        }

        if (results.length > 0) {
            return results;
        }

        return text
            .split(/[;,|/\n]/)
            .map(normalizeSizeToken)
            .filter(Boolean);
    }

    const TARGET_SUGGESTION_COUNT = 4;
    const NEAR_MATCH_MAX_DEFICIT = 1.5;
    const NEAR_MATCH_TOTAL_DEFICIT = 2.5;
    const FALLBACK_MATCH_MAX_DEFICIT = 3.0;
    const FALLBACK_MATCH_TOTAL_DEFICIT = 4.5;

    function getDimensionDiffs(inputSorted, candidateSorted) {
        const deltas = candidateSorted.map(function (dimension, index) {
            return parseFloat((dimension - inputSorted[index]).toFixed(1));
        });
        const deficits = deltas
            .filter(function (delta) {
                return delta < 0;
            })
            .map(function (delta) {
                return Math.abs(delta);
            });

        return {
            deltas: deltas,
            deficits: deficits
        };
    }

    function isCandidateEligible(inputSorted, candidateSorted, maxDeficitLimit, totalDeficitLimit) {
        const diffs = getDimensionDiffs(inputSorted, candidateSorted);

        if (diffs.deficits.length === 0) {
            return true;
        }

        const maxDeficit = Math.max.apply(null, diffs.deficits);
        const totalDeficit = parseFloat(diffs.deficits.reduce(function (sum, value) {
            return sum + value;
        }, 0).toFixed(1));

        return maxDeficit <= maxDeficitLimit && totalDeficit <= totalDeficitLimit;
    }

    function hasDeficit(inputSorted, candidateSorted) {
        return getDimensionDiffs(inputSorted, candidateSorted).deficits.length > 0;
    }

    function scoreCandidate(inputSorted, candidateSorted) {
        const diffs = getDimensionDiffs(inputSorted, candidateSorted);
        const absDiffs = diffs.deltas.map(function (delta) {
            return Math.abs(delta);
        });
        const totalAbsDelta = parseFloat(absDiffs.reduce(function (sum, value) {
            return sum + value;
        }, 0).toFixed(1));
        const totalDeficit = diffs.deficits.length > 0
            ? parseFloat(diffs.deficits.reduce(function (sum, value) {
                return sum + value;
            }, 0).toFixed(1))
            : 0;

        return {
            fitPenalty: diffs.deficits.length > 0 ? 1 : 0,
            maxAbsDelta: Math.max.apply(null, absDiffs),
            totalAbsDelta: totalAbsDelta,
            maxDeficit: diffs.deficits.length > 0 ? Math.max.apply(null, diffs.deficits) : 0,
            totalDeficit: totalDeficit,
            volumeAbsDelta: parseFloat(Math.abs(
                (candidateSorted[0] * candidateSorted[1] * candidateSorted[2]) -
                (inputSorted[0] * inputSorted[1] * inputSorted[2])
            ).toFixed(1))
        };
    }

    function isBetterScore(nextScore, currentScore) {
        if (!currentScore) return true;
        if (nextScore.maxAbsDelta !== currentScore.maxAbsDelta) return nextScore.maxAbsDelta < currentScore.maxAbsDelta;
        if (nextScore.totalAbsDelta !== currentScore.totalAbsDelta) return nextScore.totalAbsDelta < currentScore.totalAbsDelta;
        if (nextScore.fitPenalty !== currentScore.fitPenalty) return nextScore.fitPenalty < currentScore.fitPenalty;
        if (nextScore.maxDeficit !== currentScore.maxDeficit) return nextScore.maxDeficit < currentScore.maxDeficit;
        if (nextScore.totalDeficit !== currentScore.totalDeficit) return nextScore.totalDeficit < currentScore.totalDeficit;
        return nextScore.volumeAbsDelta < currentScore.volumeAbsDelta;
    }

    function parseProductData(productDataElement) {
        if (!productDataElement) return [];

        try {
            const parsed = JSON.parse(productDataElement.textContent || '[]');
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    }

    function buildProductIndex(products) {
        const indexed = [];

        products.forEach(function (product) {
            if (!product || !product.olculer) return;

            tokenizeSizes(product.olculer).forEach(function (sizeArr) {
                const sortedSize = sortDims(sizeArr);
                indexed.push({
                    title: product.title,
                    price: product.price,
                    image: product.image,
                    url: product.url,
                    olculer: product.olculer,
                    rawSize: sizeArr,
                    sortedSize: sortedSize,
                    sortedKey: sizeArrayToKey(sortedSize)
                });
            });
        });

        return indexed;
    }

    function pickBestPerProduct(candidates, inputSorted) {
        const bestByProduct = new Map();

        candidates.forEach(function (candidate) {
            const key = candidate.url || candidate.title;
            const score = scoreCandidate(inputSorted, candidate.sortedSize);
            const existing = bestByProduct.get(key);

            if (!existing || isBetterScore(score, existing.score)) {
                bestByProduct.set(key, {
                    product: candidate,
                    score: score
                });
            }
        });

        return Array.from(bestByProduct.values())
            .sort(function (a, b) {
                if (a.score.maxAbsDelta !== b.score.maxAbsDelta) return a.score.maxAbsDelta - b.score.maxAbsDelta;
                if (a.score.totalAbsDelta !== b.score.totalAbsDelta) return a.score.totalAbsDelta - b.score.totalAbsDelta;
                if (a.score.fitPenalty !== b.score.fitPenalty) return a.score.fitPenalty - b.score.fitPenalty;
                if (a.score.maxDeficit !== b.score.maxDeficit) return a.score.maxDeficit - b.score.maxDeficit;
                if (a.score.totalDeficit !== b.score.totalDeficit) return a.score.totalDeficit - b.score.totalDeficit;
                return a.score.volumeAbsDelta - b.score.volumeAbsDelta;
            })
            .map(function (entry) {
                return entry.product;
            });
    }

    function takeUniqueProducts(groups, limit) {
        const unique = [];
        const seen = new Set();

        groups.forEach(function (products) {
            products.forEach(function (product) {
                if (unique.length >= limit) return;

                const key = product.url || product.title;
                if (seen.has(key)) return;

                seen.add(key);
                unique.push(product);
            });
        });

        return unique.slice(0, limit);
    }

    function getBestFits(inputSorted, indexedProducts) {
        const fullFits = pickBestPerProduct(indexedProducts.filter(function (product) {
            return !hasDeficit(inputSorted, product.sortedSize);
        }), inputSorted);

        const nearMatches = pickBestPerProduct(indexedProducts.filter(function (product) {
            return hasDeficit(inputSorted, product.sortedSize) && isCandidateEligible(
                inputSorted,
                product.sortedSize,
                NEAR_MATCH_MAX_DEFICIT,
                NEAR_MATCH_TOTAL_DEFICIT
            );
        }), inputSorted);

        const fallbackMatches = pickBestPerProduct(indexedProducts.filter(function (product) {
            return hasDeficit(inputSorted, product.sortedSize) && isCandidateEligible(
                inputSorted,
                product.sortedSize,
                FALLBACK_MATCH_MAX_DEFICIT,
                FALLBACK_MATCH_TOTAL_DEFICIT
            );
        }), inputSorted);

        return takeUniqueProducts([
            fullFits,
            nearMatches,
            fallbackMatches
        ], TARGET_SUGGESTION_COUNT);
    }

    function renderCard(product, extraClass) {
        const cardClass = extraClass ? 'oneri-card ' + extraClass : 'oneri-card';
        const sizeMarkup = titleHasDimensions(product.title)
            ? ''
            : '  <p class="oneri-card__size"><strong>' + escapeHtml(t('sihirbaz.size_label')) + '</strong> ' + escapeHtml(formatSize(product.rawSize)) + '</p>';

        return [
            '<div class="' + cardClass + '">',
            '  <a href="' + escapeHtml(product.url) + '" class="oneri-card__link">',
            '    <img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">',
            '    <p class="oneri-card__title"><strong>' + escapeHtml(product.title) + '</strong></p>',
            '  </a>',
            sizeMarkup,
            '  <p><strong>' + escapeHtml(t('sihirbaz.price_label')) + '</strong> ' + escapeHtml(product.price) + '</p>',
            '  <a href="' + escapeHtml(product.url) + '" class="oneri-card__cta">' + escapeHtml(t('sihirbaz.product_inspect')) + '</a>',
            '</div>'
        ].join('');
    }

    async function loadAllProductsForSection(root, state) {
        if (state.loadingPromise) return state.loadingPromise;

        const totalPages = parseInt(root.dataset.totalPages || '1', 10);
        const sectionId = root.dataset.sectionId;

        if (!sectionId || totalPages <= 1) {
            state.allProductsLoaded = true;
            return Promise.resolve();
        }

        state.loadingPromise = (async function () {
            for (let page = 2; page <= totalPages; page += 1) {
                const url = new URL(window.location.href);
                url.searchParams.set('sections', sectionId);
                url.searchParams.set('page', String(page));

                const response = await fetch(url.toString(), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                if (!response.ok) {
                    throw new Error('Section products could not be loaded.');
                }

                const payload = await response.json();
                const html = payload && payload[sectionId];

                if (!html) {
                    throw new Error('Section payload missing.');
                }

                const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
                const dataElement = parsedDocument.querySelector('.sihirbaz-urun-data');
                const products = parseProductData(dataElement);

                if (products.length > 0) {
                    state.baseProducts.push.apply(state.baseProducts, products);
                }
            }

            state.indexedProducts = buildProductIndex(state.baseProducts);
            state.allProductsLoaded = true;
        })()
            .catch(function () {
                state.allProductsLoaded = false;
                throw new Error(t('sihirbaz.no_product_data'));
            })
            .finally(function () {
                state.loadingPromise = null;
            });

        return state.loadingPromise;
    }

    function createSectionController(root) {
        const form = root.querySelector('.sihirbaz-form');
        const submitButton = form ? form.querySelector('.sihirbaz-btn') : null;
        const sonucContainer = root.querySelector('.sonuc-container');
        const toggleButton = root.querySelector('.oneri-toggle');
        const sonucDiv = root.querySelector('.sihirbaz-sonuc');
        const productDataElement = root.querySelector('.sihirbaz-urun-data');
        const originalButtonText = submitButton && submitButton.textContent ? submitButton.textContent : t('sihirbaz.button_label');

        if (!form || !submitButton || !sonucContainer || !sonucDiv || !productDataElement) {
            return;
        }

        const state = {
            baseProducts: parseProductData(productDataElement),
            indexedProducts: [],
            allProductsLoaded: parseInt(root.dataset.totalPages || '1', 10) <= 1,
            loadingPromise: null
        };

        state.indexedProducts = buildProductIndex(state.baseProducts);

        if (!state.allProductsLoaded) {
            loadAllProductsForSection(root, state).catch(function () {
                return null;
            });
        }

        function setButtonState(labelKey, disabled) {
            submitButton.disabled = disabled;
            submitButton.textContent = labelKey ? t(labelKey) : originalButtonText;
        }

        function openResults() {
            sonucContainer.hidden = false;
            requestAnimationFrame(function () {
                sonucContainer.classList.add('active');
            });
        }

        function closeResults() {
            sonucContainer.classList.remove('active');
            setTimeout(function () {
                sonucContainer.hidden = true;
            }, 300);
        }

        function getInputValue(dimension) {
            const input = form.querySelector('[data-dimension="' + dimension + '"]');
            return input ? parseFloat(input.value) : NaN;
        }

        function renderSearchResult() {
            const width = getInputValue('width');
            const length = getInputValue('length');
            const height = getInputValue('height');

            if (isNaN(width) || isNaN(length) || isNaN(height) || width <= 0 || length <= 0 || height <= 0) {
                alert(t('sihirbaz.invalid_measurements'));
                setButtonState(null, false);
                return;
            }

            const inputSize = normalizeSizeToken(width + 'x' + length + 'x' + height);
            if (!inputSize) {
                alert(t('sihirbaz.invalid_format'));
                setButtonState(null, false);
                return;
            }

            if (state.indexedProducts.length === 0) {
                sonucDiv.innerHTML = '<p>' + escapeHtml(t('sihirbaz.no_product_data')) + '</p>';
                openResults();
                setButtonState(null, false);
                return;
            }

            const inputSorted = sortDims(inputSize);
            const inputKey = sizeArrayToKey(inputSorted);
            const exactMatches = state.indexedProducts.filter(function (product) {
                return product.sortedKey === inputKey;
            });

            if (exactMatches.length > 0) {
                const exactMatch = pickBestPerProduct(exactMatches, inputSorted)[0];
                sonucDiv.innerHTML = [
                    '<h3>' + escapeHtml(t('sihirbaz.exact_match_title')) + '</h3>',
                    '<div class="oneri-grid">',
                    renderCard(exactMatch, 'exact-match'),
                    '</div>'
                ].join('');
            } else {
                const bestFits = getBestFits(inputSorted, state.indexedProducts);

                if (bestFits.length === 0) {
                    sonucDiv.innerHTML = '<p>' + escapeHtml(t('sihirbaz.no_results')) + '</p>';
                } else {
                    sonucDiv.innerHTML = [
                        '<h3>' + escapeHtml(t('sihirbaz.nearest_title')) + '</h3>',
                        '<div class="oneri-grid">',
                        bestFits.map(function (product) {
                            return renderCard(product);
                        }).join(''),
                        '</div>'
                    ].join('');
                }
            }

            sonucDiv.innerHTML += '<p class="ozel-olcu-mesaj">' + t('sihirbaz.contact_cta_html') + '</p>';
            openResults();
            setButtonState(null, false);
        }

        if (toggleButton) {
            toggleButton.innerHTML = '&times;';
            toggleButton.addEventListener('click', closeResults);
        }

        form.addEventListener('submit', async function (event) {
            event.preventDefault();

            if (!state.allProductsLoaded) {
                setButtonState('sihirbaz.products_loading', true);

                try {
                    await loadAllProductsForSection(root, state);
                } catch (error) {
                    sonucDiv.innerHTML = '<p>' + escapeHtml(t('sihirbaz.no_product_data')) + '</p>';
                    openResults();
                    setButtonState(null, false);
                    return;
                }
            }

            setButtonState('sihirbaz.searching', true);
            renderSearchResult();
        });
    }

    document.querySelectorAll('.sihirbaz-content[data-section-id]').forEach(createSectionController);
});
